<template>
  <transition name="fade">
    <div v-if="notice" :class="['notice', notice.status]">
      <svg 
        fill="none" 
        title="Закрыть"
        viewBox="0 0 12 12" 
        xmlns="http://www.w3.org/2000/svg"
        @click="notice = null"
      >
        <path d="M11.7338 0.275313C11.3788 -0.0796357 10.8055 -0.0796357 10.4505 0.275313L6 4.71672L1.54949 0.266212C1.19454 -0.0887372 0.62116 -0.0887372 0.266212 0.266212C-0.0887372 0.62116 -0.0887372 1.19454 0.266212 1.54949L4.71672 6L0.266212 10.4505C-0.0887372 10.8055 -0.0887372 11.3788 0.266212 11.7338C0.62116 12.0887 1.19454 12.0887 1.54949 11.7338L6 7.28328L10.4505 11.7338C10.8055 12.0887 11.3788 12.0887 11.7338 11.7338C12.0887 11.3788 12.0887 10.8055 11.7338 10.4505L7.28328 6L11.7338 1.54949C12.0796 1.20364 12.0796 0.621161 11.7338 0.275313Z" fill="currentColor"/>
      </svg>

      <span v-text="notice.message"/>
    </div>
  </transition>
</template>


<script>
export default {
  name: 'AppNotice',

  data: () => ({ 
    timeout: null,
    notice: null,
  }),

  created() {
    this.$bus.$on('showNotification', notice => {
      clearTimeout(this.timeout);
      this.notice = notice;
      this.timeout = setTimeout(() => {
        this.notice = null;
      }, 5500);
    });
  },
};
</script>


<style lang="scss" scoped>
.notice {
  top: 20px;
  position: absolute;
  width: calc(100% - 40px);
  max-width: 400px;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  font-family: Arial, Helvetica, sans-serif;
  background: linear-gradient(90deg, var(--color-primary), var(--color-secondary));
  color: var(--color-white);
  text-align: center;
  padding: 20px 12px;
  border-radius: 8px;
  box-sizing: border-box;
  justify-self: center;
  animation: notification 3s ease;
  animation-fill-mode: forwards;
  z-index: 10;

  & > svg {
    cursor: pointer;
    opacity: .5;
    position: absolute;
    height: 10px;
    width: 10px;
    right: 10px;
    top: 10px;

    @media (hover: hover) {
      &:hover {
        opacity: .75;
      }
    }
  }
}

@keyframes notification { 
  0% {
    top: -10%;
  }
  100% {
    top: 20px;
  }
}
</style>